const linkData = [
    {
        id: 'twitters',
        title: 'Twitter Link',
        link: 'https://twitter.com/Paullizekor'
    },
    {
        id: 'btn__zuri',
        title: 'Zuri Team',
        link: 'https://training.zuri.team/'
    },
    {
        id: 'books',
        title: 'Zuri Books',
        link: 'http://books.zuri.team'
    },
    {
        id: 'book__python',
        title: 'Python Books',
        link: 'https://books.zuri.team/python-for-beginners'
    },
    {
        id: 'pitch',
        title: 'Background Check for Coders',
        link: 'https://background.zuri.team'
    },
    {
        id: 'book__design',
        title: 'Design Books',
        link: 'https://books.zuri.team/design-rules'
    },
]

export default linkData